module.exports = __webpack_public_path__ + "static/img/13.d944557.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/13.jpg
// module id = aXAG
// module chunks = 16